import { useState, useEffect } from "react";
import Series from "../components/series";

const Mangi = () => {
    const [Mangi, setMangi] = useState([]);
    const [mangiFiltred, setMangiFiltred] = useState([]);
    const [texto, setText] = useState("");

    /* Sending data to useState to use it on page*/
    useEffect(() => {
        const getMangi = async () => {
            const mangiFromServer = await fetchMangi();
            setMangi(mangiFromServer);
            setMangiFiltred(mangiFromServer);
        };
        getMangi();
    }, []);

    /* Fetching from a URL data */
    const fetchMangi = async () => {
        const res = await fetch("https://shynden.netlify.app/gu1v2.json", {
            headers: {
                "Access-Control-Allow-Origin": "application/json",
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        });
        const data = await res.json();

        return data.data;
    };

    const handleChange = (e) => {
        const keyword = e.target.value;

        if (keyword !== "") {
            const results = Mangi.filter((item) => {
                return item.title.toLowerCase().startsWith(keyword.toLowerCase());
            });
            setMangiFiltred(results);
        } else {
            setMangiFiltred(Mangi);
        }

        setText(keyword);
    };

    return (
        <div key={2} className="Main-center">
            <br />
            <input value={texto} className="writer" type="text" placeholer="Wpisuj" onChange={(e) => handleChange(e)}></input>
            <div className="Box">
                {mangiFiltred.map((Mangi) => {
                    return <Series key={Mangi.id} serie={Mangi} />;
                })}
            </div>
        </div>
    );
};

export default Mangi;
